import axios from "axios";
import { generateRequestConfig } from "./constants";
import { UploadedAttachment, uploadAttachment } from "./storageUpload";

type Evidence = { fileId: string; fileName: string; mimeType: string; size?: number };

/** Memory-only cache: retries reuse completed uploads, never browser storage. */
export type VerificationUploadCache = Map<File, UploadedAttachment>;

export async function submitVerificationEvidence(
  files: File[],
  savedEvidence: Evidence[],
  cache: VerificationUploadCache,
  onProgress: (completed: number) => void,
) {
  const evidence: Evidence[] = [];
  for (const [index, file] of files.entries()) {
    let attachment = cache.get(file);
    if (!attachment) {
      attachment = await uploadAttachment(
        file,
        "kyc_document",
        index === 0
          ? "profile.accountVerification.selfieDocumentPhoto"
          : "profile.accountVerification.supportingDocuments",
      );
      cache.set(file, attachment);
    }
    evidence.push({
      fileId: attachment.fileId,
      fileName: attachment.fileName,
      mimeType: attachment.mimeType,
      size: attachment.sizeBytes,
    });
    onProgress(index + 1);
  }
  const documents = (files.length ? evidence : savedEvidence)
    .map(({ fileId, fileName, mimeType, size }) => ({ fileId, fileName, mimeType, size }));
  if (!documents.length || documents.length > 5) throw new Error("Invalid verification evidence");

  // Submit only this section. Reviewer fields and unrelated profile drafts
  // must never be replayed as part of a KYC submission.
  const verification = {
    status: "pending",
    selfieDocumentPhoto: documents[0],
    supportingDocuments: documents.slice(1),
    consentAccepted: true,
  };
  await axios(generateRequestConfig("put", "personal_data", {
    data: { profile: { accountVerification: verification } },
  }));
  return verification;
}
